import { css, Global } from "@emotion/react"

/**
 * Intercom's launcher/messenger ships with z-index 2147483000 !important,
 * which sits above every Chakra overlay (see Tokens/Z Indices in Storybook)
 * and covers UI like the mobile menu logout button. We cap Intercom at
 * Chakra's `overlay` level so it stays below `modal` (1400), which is what
 * Drawer, Modal, Popover, Toast, and Tooltip use.
 *
 * Passed via Intercom's `z_index` config AND forced via the CSS override
 * below. The CSS override is required because Intercom documents:
 *
 *   "The Messenger on mobile web will always remain on a high z-index.
 *    Due to the size of most mobile devices, the Messenger needs to be
 *    displayed on the top of everything."
 *   — https://developers.intercom.com/installing-intercom/web/customization
 *
 * i.e. the `z_index` config is ignored on small viewports, so we override
 * the rule in CSS with `!important` ourselves.
 */
export const INTERCOM_Z_INDEX = 1300

export function IntercomZIndex() {
  return (
    <Global
      styles={css`
        .intercom-lightweight-app,
        .intercom-lightweight-app-launcher,
        .intercom-launcher-frame {
          z-index: ${INTERCOM_Z_INDEX} !important;
        }
      `}
    />
  )
}
